import React from "react";
import { Icon, Popup } from "semantic-ui-react";
import styles from "./styles.module.scss";

export interface TooltipProps {
  message: any;
}

const Tooltip = ({ message }: TooltipProps) => {
  return (
    <Popup
      position="top left"
      content={message}
      mouseEnterDelay={500}
      mouseLeaveDelay={500}
      on="hover"
      className={styles.popup}
      trigger={
        <Icon
          id="tooltip"
          className={styles.icon}
          name="question circle outline"
        />
      }
    />
  );
};
export default Tooltip;
